module.exports = __webpack_public_path__ + "img/巫山淫羊藿.a66184fb.jpg";